var _path, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCfx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3173_8476",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3173_8476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.393 -2.22754H-2.41016V22.4318H22.393V-2.22754Z",
    fill: "url(#paint0_linear_3173_8476)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3173_8476)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.60156 11.1207L9.87856 5.82147L15.2012 11.1669V8.61987L9.92416 3.26367L4.60756 8.63787L4.60156 11.1207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.82422 12.434L9.85622 16.5356L13.935 12.434L12.6906 11.1668L9.87962 14.0012L8.35862 12.434L11.1468 9.57678L9.89702 8.33838L5.82422 12.434Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3173_8476",
    x1: 1.52095,
    y1: -4.48429,
    x2: 18.3146,
    y2: 24.7722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E3EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2B4CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#17B38A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0FDC77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3173_8476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(2.40234 2.3999)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfx);
export default __webpack_public_path__ + "static/media/cfx.54132add5ee7aa85486911b4a6691259.svg";
export { ForwardRef as ReactComponent };